import { useAdminMode } from "@/contexts/admin-mode-provider";
import { useTeams } from "@/contexts/teams-provider";

/** Returns `true` when admin mode and god mode toggles are both on AND the user has god-level privileges. */
export const useGodMode = (): boolean => {
  const { isAdminMode, isGodModeEnabled } = useAdminMode();
  const { isGod } = useTeams();

  return isAdminMode && isGod && isGodModeEnabled;
};
